import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatINR, formatDate } from "../lib/api";
import { ArrowLeft, UserCheck } from "lucide-react";
import { lrStatusClass } from "./LRs";

export default function Handling() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/lrs/handled-by/${id}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [id]);

  if (!data) return <div className="text-sm text-[#68665E]">Loading…</div>;
  if (data.error) return <div className="text-sm text-[#8A2526]">Could not load handler.</div>;

  const u = data.user;
  const counts = data.status_counts || {};

  return (
    <div data-testid="handling-page">
      <button className="btn-ghost text-sm mb-4" onClick={() => navigate(-1)}><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="flex items-center gap-3 mb-6">
        <UserCheck className="w-8 h-8 text-[#C84B31]" />
        <div>
          <div className="text-xs uppercase tracking-widest text-[#68665E] font-semibold">ITO Handler · {u.role}</div>
          <h1 className="font-headings text-4xl font-bold text-[#1A1A18]" data-testid="handling-name">{u.name}</h1>
          <div className="text-sm text-[#68665E]">{u.email}</div>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-6" data-testid="handling-breakdown">
        <span className="badge-neutral" data-testid="handling-count">{data.count} LR{data.count === 1 ? "" : "s"}</span>
        {Object.entries(counts).filter(([s]) => s).map(([s, n]) => (
          <span key={s} className={lrStatusClass(s)}>{n} {s.replace(/_/g, " ")}</span>
        ))}
        <span className="badge-neutral">Freight {formatINR(data.freight_total)}</span>
      </div>

      <div className="table-wrap">
        <table className="w-full">
          <thead>
            <tr>
              <th className="table-th">LR #</th>
              <th className="table-th">Date</th>
              <th className="table-th">Consignor → Consignee</th>
              <th className="table-th">Route</th>
              <th className="table-th">Freight</th>
              <th className="table-th">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.lrs.length === 0 ? (
              <tr><td className="table-td text-center text-[#68665E]" colSpan={6}>No LRs assigned to this handler yet.</td></tr>
            ) : data.lrs.map((lr) => (
              <tr key={lr.id} className="table-row" data-testid={`handling-lr-${lr.id}`}>
                <td className="table-td font-mono text-xs"><button className="text-[#C84B31] hover:underline font-medium" onClick={() => navigate(`/lr/${lr.id}`)}>{lr.lr_number}</button></td>
                <td className="table-td">{formatDate(lr.lr_date)}</td>
                <td className="table-td">{lr.consignor_name} → {lr.consignee_name}</td>
                <td className="table-td">{lr.from_location} → {lr.to_location}</td>
                <td className="table-td font-medium">{formatINR(lr.freight_amount)}</td>
                <td className="table-td"><span className={lrStatusClass(lr.lifecycle?.effective_status || lr.status)}>{String(lr.lifecycle?.effective_status || lr.status || "").replace(/_/g, " ")}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
